import React from "react";

const Services = () => {
  return <div className="container">Services</div>;
};

export default Services;
